import * as React from "react";
const SvgLoadingIndicator = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "24px",
	height: "30px",
	viewBox: "0 0 24 30",
	style: { enableBackground: "new 0 0 50 50" },
	xmlSpace: "preserve",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	className: "loadingIndicatorRect",
	x: 0,
	width: 4
}, /* @__PURE__ */ React.createElement("animate", {
	attributeName: "opacity",
	attributeType: "XML",
	values: "0.2; 1; .2",
	begin: "0s",
	dur: "1.8s",
	repeatCount: "indefinite"
}), /* @__PURE__ */ React.createElement("animate", {
	attributeName: "height",
	attributeType: "XML",
	values: "10; 20; 10",
	begin: "0s",
	dur: "1.8s",
	repeatCount: "indefinite"
}), /* @__PURE__ */ React.createElement("animate", {
	attributeName: "y",
	attributeType: "XML",
	values: "10; 5; 10",
	begin: "0s",
	dur: "1.8s",
	repeatCount: "indefinite"
})), /* @__PURE__ */ React.createElement("rect", {
	className: "loadingIndicatorRect",
	x: 8,
	width: 4
}, /* @__PURE__ */ React.createElement("animate", {
	attributeName: "opacity",
	attributeType: "XML",
	values: "0.2; 1; .2",
	begin: "0.45s",
	dur: "1.8s",
	repeatCount: "indefinite"
}), /* @__PURE__ */ React.createElement("animate", {
	attributeName: "height",
	attributeType: "XML",
	values: "10; 20; 10",
	begin: "0.45s",
	dur: "1.8s",
	repeatCount: "indefinite"
}), /* @__PURE__ */ React.createElement("animate", {
	attributeName: "y",
	attributeType: "XML",
	values: "10; 5; 10",
	begin: "0.45s",
	dur: "1.8s",
	repeatCount: "indefinite"
})), /* @__PURE__ */ React.createElement("rect", {
	className: "loadingIndicatorRect",
	x: 16,
	width: 4
}, /* @__PURE__ */ React.createElement("animate", {
	attributeName: "opacity",
	attributeType: "XML",
	values: "0.2; 1; .2",
	begin: "0.9s",
	dur: "1.8s",
	repeatCount: "indefinite"
}), /* @__PURE__ */ React.createElement("animate", {
	attributeName: "height",
	attributeType: "XML",
	values: "10; 20; 10",
	begin: "0.9s",
	dur: "1.8s",
	repeatCount: "indefinite"
}), /* @__PURE__ */ React.createElement("animate", {
	attributeName: "y",
	attributeType: "XML",
	values: "10; 5; 10",
	begin: "0.9s",
	dur: "1.8s",
	repeatCount: "indefinite"
})));
export default SvgLoadingIndicator;
